export const titles = {
  "RED_BLOOD_CELLS": "LIVE BLOOD: ANOMALIES OF RED BLOOD CELLS",
  "WHITE_BLOOD_CELLS": "LIVE BLOOD: ANOMALIES OF WHITE BLOOD CELLS",
  "PLATELETS_AND_PLASMA": "LIVE BLOOD: ANOMALIES OF PLATELETS AND PLASMA",
  "MICROBES": "LIVE BLOOD: MICROBES",
  "PLEOMORPHIC_FROWTH_FORMS": "LIVE BLOOD: PLEOMORPHIC FORMS",
  "DRY_BLOOD": "DRY BLOOD ANOMALIES",
  "LIVE BLOOD: ANOMALIES": "LIVE BLOOD: ANOMALIES OF RED BLOOD CELLS"
};